module.exports = __webpack_public_path__ + "static/corner-780dde3e5450c29e73454d60a61eb208.png";